import { DataItem } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { DocumentProjectRelation } from '@/Data/DocumentProjectRelation/DocumentProjectRelationDataClass'
import { Opportunity } from '@/Data/Opportunity/OpportunityDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'
import { getDataItem } from '@/utils/getDataItem'
import { isString } from '@/utils/isString'

interface Args {
  subjectId: string
  search: string
  order: DataScopeOrder
  listSize: number
  subjectRelation?: 'company' | 'document'
}

interface OpportunityRow {
  id: string
  opportunity: DataItem
  relation?: DataItem
}

export const useOpportunityTabData = ({
  subjectId,
  search,
  order,
  listSize,
  subjectRelation = 'company',
}: Args) => {
  const isDocument = subjectRelation === 'document'
  const dataClass = isDocument ? DocumentProjectRelation : Opportunity
  const filters = isDocument
    ? {
        document: subjectId,
        projectEntity: DataClassName.OPPORTUNITY,
        project_search: search,
      }
    : { customer: subjectId }

  const { dataItems, hasMore, loadMore, count } = useDataClassIndex(
    dataClass,
    {
      filters,
      order: [order],
      ...(!isDocument ? { search: search || undefined } : {}),
    },
    listSize,
  )

  const items: OpportunityRow[] = dataItems.flatMap((item) => {
    if (!isDocument) {
      return [{ id: item.id(), opportunity: item }]
    }

    const projectId = item.get('project') as string
    if (!isString(projectId)) return []
    const { dataItem: opportunity } = getDataItem(Opportunity, projectId)
    if (!opportunity) return []

    return [{ id: opportunity.id(), opportunity, relation: item }]
  })

  return { items, hasMore, loadMore, count }
}
